export default "__VITE_ASSET__B8Xz9XpT__"